import { render, staticRenderFns } from "./TemplateRFCLClient.vue?vue&type=template&id=64c7ca5d&scoped=true&"
import script from "./TemplateRFCLClient.vue?vue&type=script&lang=js&"
export * from "./TemplateRFCLClient.vue?vue&type=script&lang=js&"
import style0 from "./TemplateRFCLClient.vue?vue&type=style&index=0&id=64c7ca5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c7ca5d",
  null
  
)

export default component.exports